import { render, staticRenderFns } from "./withdraw-user-config.vue?vue&type=template&id=0b974a62&scoped=true"
import script from "./withdraw-user-config.vue?vue&type=script&lang=js"
export * from "./withdraw-user-config.vue?vue&type=script&lang=js"
import style0 from "./withdraw-user-config.vue?vue&type=style&index=0&id=0b974a62&prod&scoped=true&lang=css"
import style1 from "./withdraw-user-config.vue?vue&type=style&index=1&id=0b974a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b974a62",
  null
  
)

export default component.exports